<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="会议名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.mtitle" placeholder="请输入会议名称"></el-input>
					</el-form-item>
					<el-form-item label="公司名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.companyName" placeholder="请输入公司名称"></el-input>
					</el-form-item>
					<el-form-item label="报名人" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.username" placeholder="请输入报名人"></el-input>
					</el-form-item>
					<el-form-item label="联系人" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.applicantName" placeholder="请输入联系人"></el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
				<el-button type="primary" @click="downloadFile"> 导出 </el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>

			<el-table-column prop="mtitle" label="会议名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="companyName" label="公司名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="username" label="报名人" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="peopleNum" label="参会人数" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="applicantName" label="联系人" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="applicantPhone" label="联系电话" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true">

				<template slot-scope="scope">
					<el-button @click="look(scope.row.remark)">查看</el-button>

				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div class="detailImg"  v-html="detail"></div>
			
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				detail:'',
				dialogVisibleDetails:false,
				expressList: [],
				orderInfo: {},
				storeGoodsInfo: {},
				sliderlist: [],


			}
		},
		methods: {
			//导出
			downloadFile() {
				let data = {
				...this.orderInfo
				};
				// console.log(data);
				this.$api.toExljoinlist(data).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "报名列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			look(t){
				this.dialogVisibleDetails=true
				this.detail=t
			},
			search() { //查询
				this.page.pageNum = 1;
				this.getjnlist()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				console.log('aaa')

				this.storeGoodsInfo = {}
			},
			getjnlist() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.orderInfo
					// expressName:this.orderInfo.expressName
				}
				this.$api.joinlist(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},


			pageChange(data) {
				this.page.pageNum = data
				this.getjnlist();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getjnlist()
			},
		},




		created() {
			this.getjnlist()
		}
	}
</script>

<style>

</style>